import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../data/site";
import { SEO } from "@/components/Seo";

export default function Go() {
  const navigate = useNavigate();
  useEffect(() => {
    fetch(`${API}/track/go`, { method: "POST" }).catch(() => {});
    navigate("/coming-soon?utm_source=bio&utm_medium=social", { replace: true });
  }, [navigate]);
  return (
    <div className="min-h-[60vh] flex items-center justify-center pt-24">
      <SEO title="Pranivaa Kitchens" description="Taking you to the current drop." path="/go" noindex />
      <p className="font-mono text-xs tracking-[0.25em] uppercase text-ink-muted">Taking you to the drop…</p>
    </div>
  );
}
